import PropTypes from 'prop-types';

const CloseSliderButton = props => (
  <button
    className="fullscreen-slider__close-button"
    type="button"
    onClick={props.onClick}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <g fill="#FFF" fillRule="evenodd">
        <path d="M17.738.768l1.061 1.06L1.829 18.8l-1.061-1.06z" />
        <path d="M18.799 17.738l-1.06 1.061L.767 1.829 1.828.767z" />
      </g>
    </svg>
  </button>
);

CloseSliderButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default CloseSliderButton;
